/**
 * 机器码字体（JetBrains Mono）的注册。
 *
 * ## 这个字体解决什么
 *
 * 钱包码的零（`0`）与字母 `O` 只差一笔：抄错一位就是兑换失败。
 * JetBrains Mono 的零字形**自带斜杠**（零 = 外框 + 斜杠；字母 `O` 只有外框），
 * 且是**可变字重**文件（wght 400–800）——一份文件覆盖常规与加粗。
 *
 * 系统等宽字体（Menlo / Consolas / SF Mono）的零多半是光秃秃的椭圆
 * ⇒ 同一屏上 `O` 与 `0` 只能靠宽度猜 ⇒ 字体必须**随应用分发**，
 * 不能指望用户机器上装了什么。
 *
 * ## 为什么用 FontFace API 而不是 @font-face
 *
 * 本树约定不建 .css/.scss/.less（`scripts/check-ui-discipline.mjs` 卡死）
 * ⇒ `@font-face` 无处声明 ⇒ 走 CSS Font Loading API（同一套字体合成机制，
 * 声明写在 TS 里）。
 *
 * ## 加载失败怎么办
 *
 * **不抛错**：把加载失败的 face 从 font set 摘掉 ⇒ 浏览器回落系统等宽字体
 * ⇒ 页面照常可用，只是零没有斜杠。
 *
 * ## 字体来源
 *
 * Google Fonts 的 `JetBrains Mono` latin 子集（可变字重 woff2，31KB）。
 * 许可证 SIL OFL 1.1 —— 随字体分发许可证原文在 `public/fonts/OFL-1.1.txt`。
 */

const CODE_FONT_FAMILY = 'JetBrains Mono';

/** 可变字重 woff2（latin 子集，wght 400–800）。BASE_URL 前缀 ⇒ 子路径部署也成立。 */
const CODE_FONT_URL = `${import.meta.env.BASE_URL}fonts/jetbrains-mono-latin-var.woff2`;

let registered = false;

/** 注册机器码字体。幂等 ⇒ 多次调用只注册一次；失败静默回落。 */
export function ensureCodeFont(): void {
  if (registered) return;
  registered = true;
  if (typeof document === 'undefined' || typeof FontFace === 'undefined') return;
  const face = new FontFace(CODE_FONT_FAMILY, `url(${CODE_FONT_URL})`, {
    weight: '400 800',
    style: 'normal',
    display: 'swap',
  });
  document.fonts.add(face);
  face.load().catch(() => {
    document.fonts.delete(face);
  });
}
